/**
 * Loxley, drawn in SVG from theme roles only, so the body is sapphire in the
 * light theme and green in dark, with the amber accent for the eyes and the
 * target on the antenna (Loxley hits the target: the quota, every month).
 *
 * `state` drives small CSS motions in loxley.css; reduced-motion turns them off.
 */
export type LoxleyMood = "idle" | "thinking" | "listening" | "done";

export function LoxleyCharacter({ mood = "idle", className }: { mood?: LoxleyMood; className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={`loxley-character${className ? ` ${className}` : ""}`}
      data-mood={mood}
      aria-hidden="true"
      focusable="false"
    >
      <g className="loxley-antenna">
        <line x1="32" y1="12" x2="32" y2="7" className="loxley-stroke-edge" />
        <circle cx="32" cy="5" r="4.2" className="loxley-fill-target" />
        <circle cx="32" cy="5" r="2.6" className="loxley-fill-target-ring" />
        <circle cx="32" cy="5" r="1.2" className="loxley-fill-target" />
      </g>
      <rect x="5" y="24" width="5" height="11" rx="2.5" className="loxley-fill-edge" />
      <rect x="54" y="24" width="5" height="11" rx="2.5" className="loxley-fill-edge" />
      <rect x="9" y="12" width="46" height="34" rx="13" className="loxley-fill-body" />
      <rect x="15" y="19" width="34" height="19" rx="9.5" className="loxley-fill-visor" />
      <g className="loxley-eyes">
        <rect x="21.5" y="24" width="7" height="8" rx="3.5" className="loxley-fill-eye" />
        <rect x="35.5" y="24" width="7" height="8" rx="3.5" className="loxley-fill-eye" />
      </g>
      <path d="M27 35 Q32 37.5 37 35" className="loxley-smile" />
      <rect x="21" y="47" width="22" height="12" rx="6" className="loxley-fill-body" />
      <circle cx="32" cy="53" r="2.6" className="loxley-fill-eye loxley-chest" />
    </svg>
  );
}
